var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SUJNhpmDQDF27Y3OfwgfYa",
    x1: 19,
    x2: 19,
    y1: 24.858,
    y2: 49.041,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SUJNhpmDQDF27Y3OfwgfYa)",
    fillRule: "evenodd",
    d: "M22 48L22 26 16 26 16 48 22 48z",
    clipRule: "evenodd"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SUJNhpmDQDF27Y3OfwgfYb",
    x1: 19.382,
    x2: 19.382,
    y1: 15.423,
    y2: 23.341,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SUJNhpmDQDF27Y3OfwgfYb)",
    fillRule: "evenodd",
    d: "M19.358,23c2.512,0,4.076-1.474,4.076-3.554 c-0.047-2.126-1.564-3.649-4.028-3.649c-2.465,0-4.076,1.475-4.076,3.601c0,2.08,1.563,3.602,3.981,3.602H19.358L19.358,23z",
    clipRule: "evenodd"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SUJNhpmDQDF27Y3OfwgfYc",
    x1: 37.386,
    x2: 37.386,
    y1: 14.125,
    y2: 49.525,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SUJNhpmDQDF27Y3OfwgfYc)",
    fillRule: "evenodd",
    d: "M26.946,48H34V35.911c0-0.648,0.122-1.295,0.313-1.758 c0.52-1.295,1.877-2.635,3.867-2.635c2.607,0,3.821,1.988,3.821,4.901V48h6V35.588c0-6.657-3.085-9.498-7.826-9.498 c-3.886,0-5.124,1.91-6.072,3.91H34v-4h-7.054c0.095,2-0.175,22-0.175,22H26.946z",
    clipRule: "evenodd"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SUJNhpmDQDF27Y3OfwgfYd",
    x1: 32,
    x2: 32,
    y1: 6.5,
    y2: 57.5,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SUJNhpmDQDF27Y3OfwgfYd)",
    d: "M50,57H14c-3.859,0-7-3.141-7-7V14c0-3.859,3.141-7,7-7h36c3.859,0,7,3.141,7,7v36 C57,53.859,53.859,57,50,57z M14,9c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h36c2.757,0,5-2.243,5-5V14c0-2.757-2.243-5-5-5H14z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.42bdd188754de5d746f53c7ddef28ca1.svg";
export { ForwardRef as ReactComponent };